// extracted by mini-css-extract-plugin
export default {"modalWrap":"_3f9cm3","modalWrap__container":"_2owPqP","title":"_3i34Kv","header":"meJG9z","text":"_3wsMLC","btns":"Z9w6YU"};